import type { FacilityLoginResponse } from '../../API/services/loginServices';
const USER_STORAGE_KEY = 'user';

export const setUserToStorage = (user: FacilityLoginResponse) => {
  localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
};

export const getUserFromStorage = (): FacilityLoginResponse | null => {
  const user = localStorage.getItem(USER_STORAGE_KEY);
  return user ? JSON.parse(user) : null;
};

export const clearUserFromStorage = () => {
  localStorage.removeItem(USER_STORAGE_KEY);
};

export const hasRole = (roles: FacilityLoginResponse['role'][]) => {
  const user = getUserFromStorage();
  if (!user?.role) return false;
  const userRole = user.role.toLowerCase();
  return roles.map((r) => r.toLowerCase()).includes(userRole);
};

export const getAuthToken = (): string | null => {
  const user = getUserFromStorage();
  return user?.accessToken ?? null;
};
